var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sideInfo"},[(!_vm.edit)?[(!_vm.edit)?_c('EditBtn',{directives:[{name:"show",rawName:"v-show",value:(!_vm.btnHide),expression:"!btnHide"}],style:({
      position: 'absolute',
      top: '8px',
      right: '12px'
    }),on:{"click":function($event){return _vm.$emit('edit')}}}):_vm._e(),_vm._t("default")]:[_vm._t("edit"),_c('Btns',{on:{"save":function($event){return _vm.$emit('save')},"cancel":function($event){return _vm.$emit('cancel')}}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }